import ListViewRowWrapper from "core/components/ListViewRowWrapper";
import Row from "components/broadcasts/BroadcastTableRow";
import PropTypes from "prop-types";
import React from "react";

const Table = ({ broadcasts, loading, onBottomScroll }) => {
    const rows = broadcasts.map(x => <Row broadcast={x} key={x.id} />);
    const columns = ["Cuándo", "Asunto", "Contenido", "Recipientes"];
    return (
        <table className="table table-hover">
            <thead><tr>{columns.map((x, idx) => <th key={idx}>{x}</th>)}</tr></thead>
            <tbody>
                <ListViewRowWrapper
                    rows={rows}
                    numberOfColumns={columns.length}
                    loading={loading}
                    onBottomScroll={onBottomScroll}
                />
            </tbody>
        </table>
    );
};

Table.propTypes = {
    broadcasts: PropTypes.arrayOf(PropTypes.any).isRequired,
    loading: PropTypes.bool.isRequired,
    onBottomScroll: PropTypes.func.isRequired
};

export default Table;
